// extracted by mini-css-extract-plugin
export default {"item":"constructor-ingredient_item__J+l83"};